module.exports = __webpack_public_path__ + "img/As.3cf423b5.png";